// Shared by the blotters that open the standard deal slip (DealSlipViewModal)
// from a summary row: which slip layout each deal type uses, and the record
// shape the slip expects.

/** Blotter deal type -> DealSlipViewModal `dealType`. Types not listed have no slip. */
export const SLIP_DEAL_TYPE = {
  GSEC: 'GSec',
  TBILL: 'GSec',
  BUYBACK: 'Buyback',
  MONEY_MARKET: 'MoneyMarket',
  REPO: 'Repo'
};

/** Full deal record (from /daily-deal-blotter/deal) -> the slip's `transaction`. */
export function toSlipTransaction(dealType, record, counterparty) {
  const base = { ...record, counterparty_name: record.counterparty_name || counterparty };
  if (dealType !== 'REPO') return base;
  // Same field mapping the Repo authorization blotter uses for this modal.
  return {
    ...base,
    maturity_value: record.maturity_amount,
    collateral_face_value: record.face_value || record.face_value_as_per_counterparty,
    status: record.approval_status
  };
}
